<template>
  <div class="project-item">
    <div class="project-item-wrapper">
      <router-link :to="link" tag="div" class="project-cover" @click.native="track">
        <div class="cover-img" :style="{'background-image':'url('+hostUrl +projectData.picture+')'}"></div>
        <div class="project-themes clearfix">
          <div class="theme-tag">
            <div class="theme-name">{{projectData.theme}}</div>
          </div>
        </div>
      </router-link>
      <div class="project-desc">
        <div class="desc-inner">
          <router-link :to="link" tag="h5" class="project-name" @click.native="track">{{projectData.event_name}}</router-link>
          <div class="project-sub-name">{{projectData.event_summary}}</div>
          <div class="project-location">
            <div>
              <img class="icon" src="~@static/fundingnew/profile/icon-location.png" />
            </div>
            <div class="text">{{projectData.city}}</div>
          </div>

          <div class="project-location">
            <div>
              <img class="icon" src="~@static/fundingnew/profile/icon-like.png" />
            </div>
            <div class="text">{{projectData.total}}</div>
          </div>
          <router-link :to="link" tag="div" class="project-link pink-circle-btn" @click.native="track">查看详情</router-link>
        </div>
      </div>
    </div>
    <!-- <tags-list :tags="projectData.tags"></tags-list> -->
    <div class="v2-tags-list clearfix">
      <div class="item-box" v-for="item of projectData.tags" :key="item">
        <div class="tag-item special"> #{{item}} </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { behavior } from '@/utils/behavior'

export default {
  name: 'ProjectItemMy',
  props: {
    projectData: Object,
    isJoin: Boolean,
  },
  data() {
    return {
      hostUrl: this.$apiConfig.host,
      likedLeast: 100,
      link: '',
    }
  },
  methods: {
    track() {
      _jcq.push([
        '_track',
        'yjhbcinfo_check',
        {
          title: this.projectData.event_name,
        },
      ])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc3', name: this.projectData.event_name })
    },
  },
  mounted() {
    let query = ''
    if (this.isJoin) {
      query = '?path_from=join'
    }
    this.link = '/fundingnew/project/' + this.projectData.id + query
  },
  computed: {
    ...mapState(['authorization']),
  },
}
</script>

<style lang="scss" scoped>
.project-item {
  .project-item-wrapper {
    display: flex;
    position: relative;
    align-items: center;
  }
  .project-cover {
    position: relative;
    width: pxtow(286);
    height: pxtow(286);
    cursor: pointer;
    overflow: hidden;
    .cover-img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      background-position: 50% 50%;
      background-size: cover;
    }
    .project-special-tag {
      position: absolute;
      z-index: 1;
      top: 6px;
      left: 6px;
      width: 60px;
      height: 60px;
    }
    .project-status {
      @include display-flex;
      position: absolute;
      z-index: 1;
      top: 6px;
      left: 6px;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      font-weight: bold;
      font-size: 1.5rem;
      color: #fff;
      align-items: center;
      justify-content: center;
      .row {
        width: 100%;
        text-align: center;
      }
      &.blue {
        background-color: #0033a0;
      }
      &.pink {
        background-color: nth($pink, 1);
      }
    }
  }
  .project-desc {
    flex: 1;
    height: pxtow(256);
    display: flex;
    align-items: center;
    padding: 0 12px;
    background: rgba(0, 51, 160, 0.5);
    border-radius: 0 5px 5px 0;
  }
  .project-name {
    @include limit-line(1);
    margin-bottom: 4px;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
  }
  .project-sub-name {
    @include limit-line(1);
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.05em;
    color: rgba(255, 255, 255, 1);
  }
  .icon {
    width: 12px;
    height: auto;
    margin: 0 8px 0 0;
  }

  .project-themes {
    position: absolute;
    left: 10px;
    bottom: 10px;
    .theme-tag {
      float: left;
      height: 32px;
      overflow: hidden;
      &:before {
        content: '';
        background: #37d42f;
        width: 110%;
        height: 8px;
        border-radius: 4px;
        position: absolute;
        bottom: 9px;
        left: -5%;
      }
      .tag-title {
        float: left;
        width: 24px;
        padding: 0 4px;
        text-align: center;
        font-weight: 500;
        font-size: 1.1rem;
        color: #fff;
        background-color: nth($pink, 1);
      }
      .theme-name {
        float: left;
        line-height: 30px;
        // padding: 0 10px;
        font-size: 1.2rem;
        color: #fff;
        position: relative;
      }
    }
  }
  .project-description {
    height: 60px;
    @include limit-line(3);
    margin: 4px 0 10px;
    font-weight: bold;
    font-size: 1.5rem;
    color: rgba(255, 255, 255, 0.75);
  }
  .project-location {
    @include display-flex;
    font-weight: 500;
    font-size: 1.2rem;
    color: rgba(255, 255, 255, 0.5);
    .iconfont {
      display: inline-block;
      margin: -4px 3px 0 0;
      vertical-align: middle;
    }
  }
  .progress-status {
    margin-top: 6px;
    .progress-bar {
      width: 100%;
      height: 8px;
      padding: 1px;
      border: 1px solid rgba(255, 255, 255, 0.75);
      background-color: rgba(255, 255, 255, 0.25);
      overflow: hidden;
      .progress-current {
        max-width: 100%;
        height: 4px;
        background: nth($pink, 1);
      }
    }
    .progress-text {
      margin-top: 4px;
      font-size: 1.2rem;
      color: rgba(255, 255, 255, 0.75);
    }
  }
  .project-tips {
    font-size: 1.2rem;
    color: rgba(255, 255, 255, 0.5);
  }
  .project-link {
    font-size: pxtow(22);
    color: #fff;
    width: pxtow(160);
    height: pxtow(60);
    line-height: pxtow(60);
    position: absolute;
    right: pxtow(-13);
    bottom: pxtow(-15);
    text-align: center;
    min-width: auto;
    cursor: pointer;
  }
}

.v2-tags-list {
  display: flex;
  justify-content: center;
  margin: pxtow(50) 0 0;
  height: pxtow(54);
  .item-box {
    display: flex;
    align-items: center;
    border: 1px solid #fff;
    border-radius: pxtow(30);
    padding: 0 pxtow(15);
    font-size: pxtow(22);
    margin: 0 pxtow(10);
    width: pxtow(186);
    .tag-item {
      white-space: nowrap;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/components/ProjectItemMy.vue